// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://snowscan.xyz/address/0xebEfEAA58636DF9B20a4fAd78Fad8759e6A20e87
export const WBTCe_Proof_of_Reserves = '0xebEfEAA58636DF9B20a4fAd78Fad8759e6A20e87';

// https://snowscan.xyz/address/0x735f816f63890c6E9FF28484E2d257e9c5dc4788
export const YETH_ETH_Exchange_Rate = '0x735f816f63890c6E9FF28484E2d257e9c5dc4788';

// https://snowscan.xyz/address/0x0A6fd6F735faCD3Cdb1D5aE1c74ebd54a4fc3CCf
export const GLV_AVAX_USDC___USD = '0x0A6fd6F735faCD3Cdb1D5aE1c74ebd54a4fc3CCf';

// https://snowscan.xyz/address/0x6f2A1D4014FED967172FC7caCf7a6e04Cf02752e
export const SAND__USD = '0x6f2A1D4014FED967172FC7caCf7a6e04Cf02752e';

// https://snowscan.xyz/address/0x1ff75B09dC8B749252F46ec482c8a4700Eb6C644
export const savUSD_vUSD_Exchange_Rate = '0x1ff75B09dC8B749252F46ec482c8a4700Eb6C644';

// https://snowscan.xyz/address/0x01752eAAB988ECb0ceBa2C8FC97c4f1d38Bf246D
export const SNX__USD = '0x01752eAAB988ECb0ceBa2C8FC97c4f1d38Bf246D';

// https://snowscan.xyz/address/0x1F41EF93dece881Ad0b98082B2d44D3f6F0C515B
export const XAU__USD = '0x1F41EF93dece881Ad0b98082B2d44D3f6F0C515B';

// https://snowscan.xyz/address/0xCF60B4E089eA1ABA29C01b017b38c2f7D69Eb36B
export const WSTETH__ETH = '0xCF60B4E089eA1ABA29C01b017b38c2f7D69Eb36B';

// https://snowscan.xyz/address/0x7B0ca9A6D03FE0467A31Ca850f5bcA51e027B3aF
export const ALPHA__USD = '0x7B0ca9A6D03FE0467A31Ca850f5bcA51e027B3aF';

// https://snowscan.xyz/address/0x7Ee401373A92f885a7C3A53CF46dbe661eaFb1C0
export const SHIB__USD = '0x7Ee401373A92f885a7C3A53CF46dbe661eaFb1C0';

// https://snowscan.xyz/address/0x52F8026423B5E04FdD9E4b5725B68230b71D019b
export const CVX__USD = '0x52F8026423B5E04FdD9E4b5725B68230b71D019b';

// https://snowscan.xyz/address/0x1f9789982b7c72FFFa1874f0017F7de9BBdA0901
export const WSRUSD__RUSD_Exchange_Rate = '0x1f9789982b7c72FFFa1874f0017F7de9BBdA0901';

// https://snowscan.xyz/address/0xA5ecED13b233BcF5c58BFbada5247d5B2893cB9a
export const Exchange_Rate_ggAVAX__AVAX = '0xA5ecED13b233BcF5c58BFbada5247d5B2893cB9a';

// https://snowscan.xyz/address/0x976D7fAc81A49FA71EF20694a3C56B9eFB93c30B
export const DAIe_Proof_of_Reserves = '0x976D7fAc81A49FA71EF20694a3C56B9eFB93c30B';

// https://snowscan.xyz/address/0x36E039e6391A5E7A7267650979fdf613f659be5D
export const QI__USD = '0x36E039e6391A5E7A7267650979fdf613f659be5D';

// https://snowscan.xyz/address/0x54EdAB30a7134A16a54218AE64C73e1DAf48a8Fb
export const MIM__USD = '0x54EdAB30a7134A16a54218AE64C73e1DAf48a8Fb';

// https://snowscan.xyz/address/0x192f2DBA961Bb0277520C082d6bfa87D5961333E
export const EUR__USD = '0x192f2DBA961Bb0277520C082d6bfa87D5961333E';

// https://snowscan.xyz/address/0xe89B3CE86D25599D1e615C0f6a353B4572FF868D
export const BAT__USD = '0xe89B3CE86D25599D1e615C0f6a353B4572FF868D';

// https://snowscan.xyz/address/0xc79a363a3f849d8b3F6A1932f748eA9d4fB2f607
export const Re_Offchain_Reserves = '0xc79a363a3f849d8b3F6A1932f748eA9d4fB2f607';

// https://snowscan.xyz/address/0xfAa665F5a0e13beea63b6DfF601DD634959690Df
export const WOO__ETH = '0xfAa665F5a0e13beea63b6DfF601DD634959690Df';

// https://snowscan.xyz/address/0xA418573AB5226711c8564Eeb449c3618ABFaf677
export const CHF__USD = '0xA418573AB5226711c8564Eeb449c3618ABFaf677';

// https://snowscan.xyz/address/0x41185495Bc8297a65DC46f94001DC7233775EbEe
export const AAVE_Network_Emergency_Count_Avalanche = '0x41185495Bc8297a65DC46f94001DC7233775EbEe';

// https://snowscan.xyz/address/0x9df2195dc96e6Ef983B1aAC275649F3f28F82Aa1
export const KNC__USD = '0x9df2195dc96e6Ef983B1aAC275649F3f28F82Aa1';

// https://snowscan.xyz/address/0x05950959B6d876ae0fed1BBe5Caa2d74d8659D59
export const SGD__USD = '0x05950959B6d876ae0fed1BBe5Caa2d74d8659D59';

// https://snowscan.xyz/address/0x3Eb06AE1Ef3adE7B529Fcce522611c6A044697cC
export const Real_GDP_Percent_Change_Annual_Rate = '0x3Eb06AE1Ef3adE7B529Fcce522611c6A044697cC';

// https://snowscan.xyz/address/0x665Fa131DE7af7606c785F26e66d07cA43a274D9
export const Real_GDP_Level = '0x665Fa131DE7af7606c785F26e66d07cA43a274D9';

// https://snowscan.xyz/address/0x86442E3a98558357d46E6182F4b262f76c4fa26F
export const WBTC__USD = '0x86442E3a98558357d46E6182F4b262f76c4fa26F';

// https://snowscan.xyz/address/0x69C2703b8F1A85a2EF6aBDd085699a9F909BE053
export const ADA__USD = '0x69C2703b8F1A85a2EF6aBDd085699a9F909BE053';

// https://snowscan.xyz/address/0x99311B4bf6D8E3D3B4b9fbdD09a1B0F4Ad8e06E9
export const BTCb_Proof_of_Reserves = '0x99311B4bf6D8E3D3B4b9fbdD09a1B0F4Ad8e06E9';

// https://snowscan.xyz/address/0x5C2d58627Fbe746f5ea24Ef6D618f09f8e3f0122
export const AUSD__USD = '0x5C2d58627Fbe746f5ea24Ef6D618f09f8e3f0122';

// https://snowscan.xyz/address/0x273e7833604F74a6f80f6B25568D29DE33570e99
export const Real_Final_Sales_to_Private_Domestic_Purchasers_Percent_Change_Annual_Rate =
  '0x273e7833604F74a6f80f6B25568D29DE33570e99';

// https://snowscan.xyz/address/0x4Cf57DC9028187b9DAaF773c8ecA941036989238
export const XAVA__USD = '0x4Cf57DC9028187b9DAaF773c8ecA941036989238';

// https://snowscan.xyz/address/0xf58B78581c480caFf667C63feDd564eCF01Ef86b
export const USTC__USD = '0xf58B78581c480caFf667C63feDd564eCF01Ef86b';

// https://snowscan.xyz/address/0x155835C5755205597d62703a5A0b37e57a26Ee5C
export const AXS__USD = '0x155835C5755205597d62703a5A0b37e57a26Ee5C';

// https://snowscan.xyz/address/0xbBa56eF1565354217a3353a466edB82E8F25b08e
export const FRAX__USD = '0xbBa56eF1565354217a3353a466edB82E8F25b08e';

// https://snowscan.xyz/address/0xFA38289Fe9f043aD8CCD8e81b28C1D02666D51b6
export const WRSETH_ETH_Exchange_Rate = '0xFA38289Fe9f043aD8CCD8e81b28C1D02666D51b6';

// https://snowscan.xyz/address/0x02D35d3a8aC3e1626d3eE09A78Dd87286F5E8e3a
export const JOE__USD = '0x02D35d3a8aC3e1626d3eE09A78Dd87286F5E8e3a';

// https://snowscan.xyz/address/0xd604e3c218d567b648Cd4B81cCd7Dddb56696331
export const WSTLINK_LINK_Exchange_Rate = '0xd604e3c218d567b648Cd4B81cCd7Dddb56696331';

// https://snowscan.xyz/address/0x943cEF1B112Ca9FD7EDaDC9A46477d3812a382b6
export const LINKe_Proof_of_Reserves = '0x943cEF1B112Ca9FD7EDaDC9A46477d3812a382b6';

// https://snowscan.xyz/address/0x982057Fd0A53d52E558A722ba53Ad95E702Da0dF
export const Real_Final_Sales_to_Private_Domestic_Purchasers_Level =
  '0x982057Fd0A53d52E558A722ba53Ad95E702Da0dF';

// https://snowscan.xyz/address/0xF096872672F44d6EBA71458D74fe67F9a77a23B9
export const USDC__USD = '0xF096872672F44d6EBA71458D74fe67F9a77a23B9';

// https://snowscan.xyz/address/0x1b8a25F73c9420dD507406C3A3816A276b62f56a
export const LINK__AVAX = '0x1b8a25F73c9420dD507406C3A3816A276b62f56a';

// https://snowscan.xyz/address/0x7CFb9D83BD42e4522BE2B9032Bcf21fBA9313C51
export const SPSEI__SEI_Exchange_Rate = '0x7CFb9D83BD42e4522BE2B9032Bcf21fBA9313C51';

// https://snowscan.xyz/address/0x449A373A090d8A1e5F74c63Ef831Ceff39E94563
export const SUSHI__USD = '0x449A373A090d8A1e5F74c63Ef831Ceff39E94563';

// https://snowscan.xyz/address/0x545d17579D0F7b422Cd647B9E6a6FA4b45F6e1C5
export const CZK__USD = '0x545d17579D0F7b422Cd647B9E6a6FA4b45F6e1C5';

// https://snowscan.xyz/address/0x3427232b88Ce4e7d62A03289247eE0cA5324f6ba
export const BEAM__USD = '0x3427232b88Ce4e7d62A03289247eE0cA5324f6ba';

// https://snowscan.xyz/address/0xB5f607A2bb2C950053F4DA1F535180e5902EAD16
export const WSTETH__USD = '0xB5f607A2bb2C950053F4DA1F535180e5902EAD16';

// https://snowscan.xyz/address/0x7B0e7d292d414788B080EfCa58b04B6372789639
export const POL__USD = '0x7B0e7d292d414788B080EfCa58b04B6372789639';

// https://snowscan.xyz/address/0x4F3ddF9378a4865cf4f28BE51E10AECb83B7daeE
export const SPELL__USD = '0x4F3ddF9378a4865cf4f28BE51E10AECb83B7daeE';

// https://snowscan.xyz/address/0xA61bF273688Ea095b5e4c11f1AF5E763F7aEEE91
export const TRY__USD = '0xA61bF273688Ea095b5e4c11f1AF5E763F7aEEE91';

// https://snowscan.xyz/address/0x84FF93CAD57DcD39b21895171D30A7A0e7851C75
export const wstETH_stETH_Exchange_Rate = '0x84FF93CAD57DcD39b21895171D30A7A0e7851C75';

// https://snowscan.xyz/address/0x908C8195E085b3290d335014B94E6F1C886a889F
export const SYRUPUSDT__USD_Exchange_Rate = '0x908C8195E085b3290d335014B94E6F1C886a889F';

// https://snowscan.xyz/address/0xfD2b540D6c147D0889A1F1B97a2A9aB694992677
export const fsBTC_Frictionless_Bitcoin_Treasury_Fund_Reserves =
  '0xfD2b540D6c147D0889A1F1B97a2A9aB694992677';

// https://snowscan.xyz/address/0xc0990e0989141a5F535a2a24b6Af65618CC83d32
export const SolvBTCBBN__SolvBTC_Exchange_Rate = '0xc0990e0989141a5F535a2a24b6Af65618CC83d32';

// https://snowscan.xyz/address/0x2F194315f122d374a27973e259783d5C864A5bf6
export const FIL__USD = '0x2F194315f122d374a27973e259783d5C864A5bf6';

// https://snowscan.xyz/address/0x076DE3812BDbdAe1330064fc01Adf7f4EAa123f3
export const GHO__USD = '0x076DE3812BDbdAe1330064fc01Adf7f4EAa123f3';

// https://snowscan.xyz/address/0x5ff6c083B7B2BD0D61beB7173B3757e1a1e6E1C6
export const solvBTC__BTC = '0x5ff6c083B7B2BD0D61beB7173B3757e1a1e6E1C6';

// https://snowscan.xyz/address/0xb7441BBD0298aaeF4f2BbD40E8025Cf59cA6E8D5
export const SUSDE_USDE_Exchange_Rate = '0xb7441BBD0298aaeF4f2BbD40E8025Cf59cA6E8D5';

// https://snowscan.xyz/address/0x3F968A21647d7ca81Fb8A5b69c0A452701d5DCe8
export const GMX__USD = '0x3F968A21647d7ca81Fb8A5b69c0A452701d5DCe8';

// https://snowscan.xyz/address/0xd99bcAdbE216D82f4B77eC54a99ea1b6bA96549b
export const ARB__USD = '0xd99bcAdbE216D82f4B77eC54a99ea1b6bA96549b';

// https://snowscan.xyz/address/0x32543Ad9dDAC8f883eE4d3c0a21a24E095A9E1B0
export const XCU__USD = '0x32543Ad9dDAC8f883eE4d3c0a21a24E095A9E1B0';

// https://snowscan.xyz/address/0x0AB119EB3f6820BA43c345e9aAbF1e3dE3C09Ce4
export const Ion_Digital_Total_Reserve = '0x0AB119EB3f6820BA43c345e9aAbF1e3dE3C09Ce4';

// https://snowscan.xyz/address/0x51D7180edA2260cc4F6e4EebB82FEF5c3c2B8300
export const DAI__USD = '0x51D7180edA2260cc4F6e4EebB82FEF5c3c2B8300';

// https://snowscan.xyz/address/0x49ccd9ca821EfEab2b98c60dC60F518E765EDe9a
export const LINK__USD = '0x49ccd9ca821EfEab2b98c60dC60F518E765EDe9a';

// https://snowscan.xyz/address/0x976B3D034E162d8bD72D6b9C989d545b839003b0
export const ETH__USD = '0x976B3D034E162d8bD72D6b9C989d545b839003b0';

// https://snowscan.xyz/address/0xc43861646Cdc051D04CA0c9dF2265FFcFa0dF6f3
export const MATICX__USD_Calculated = '0xc43861646Cdc051D04CA0c9dF2265FFcFa0dF6f3';

// https://snowscan.xyz/address/0xC63eD21bb4577Ff5a762591c73D4b0BCCfAD7AEb
export const syrupUSDC_USDC_Exchange_Rate = '0xC63eD21bb4577Ff5a762591c73D4b0BCCfAD7AEb';

// https://snowscan.xyz/address/0x962Aba596fe6842D644c51b2F112190e6B6e94B4
export const PCE_Price_Index_Level = '0x962Aba596fe6842D644c51b2F112190e6B6e94B4';

// https://snowscan.xyz/address/0xD73a74314AcCb53b30cAfDA0cb61c9772B57C4a2
export const DOT__USD = '0xD73a74314AcCb53b30cAfDA0cb61c9772B57C4a2';

// https://snowscan.xyz/address/0x14C4c668E34c09E1FBA823aD5DB47F60aeBDD4F7
export const AAVEe_Proof_of_Reserves = '0x14C4c668E34c09E1FBA823aD5DB47F60aeBDD4F7';

// https://snowscan.xyz/address/0x9a1372f9b1B71B3A5a72E092AE67E172dBd7Daaa
export const UNI__USD = '0x9a1372f9b1B71B3A5a72E092AE67E172dBd7Daaa';

// https://snowscan.xyz/address/0x5D1F504211c17365CA66353442a74D4435A8b778
export const MIMATIC__USD = '0x5D1F504211c17365CA66353442a74D4435A8b778';

// https://snowscan.xyz/address/0xDDaf9290D057BfA12d7576e6dADC109421F31948
export const WETHe_Proof_of_Reserves = '0xDDaf9290D057BfA12d7576e6dADC109421F31948';

// https://snowscan.xyz/address/0x7FDE7f51dc2580dd051e17A333E28CDC8176da0A
export const NEAR__USD = '0x7FDE7f51dc2580dd051e17A333E28CDC8176da0A';

// https://snowscan.xyz/address/0xA771e0D1e9E1eCc07C56CC38240779E54337d682
export const XAG__USD = '0xA771e0D1e9E1eCc07C56CC38240779E54337d682';

// https://snowscan.xyz/address/0xFbAc2cBC1c0083D4edC9ce47F72F3B0D9bc67F9C
export const wstPOL_POL_Exchange_Rate = '0xFbAc2cBC1c0083D4edC9ce47F72F3B0D9bc67F9C';

// https://snowscan.xyz/address/0xf8B283aD4d969ECFD70005714DD5910160565b94
export const JPY__USD = '0xf8B283aD4d969ECFD70005714DD5910160565b94';

// https://snowscan.xyz/address/0x9D6AA0AC8c4818433bEA7a74F49C73B57BcEC4Ec
export const COMP__USD = '0x9D6AA0AC8c4818433bEA7a74F49C73B57BcEC4Ec';

// https://snowscan.xyz/address/0x55b5dc7d7CDD5d3b2Eb189bf11140839076E5d40
export const xSolvBTC_NAV = '0x55b5dc7d7CDD5d3b2Eb189bf11140839076E5d40';

// https://snowscan.xyz/address/0x9Cf3Ef104A973b351B2c032AA6793c3A6F76b448
export const TUSD__USD = '0x9Cf3Ef104A973b351B2c032AA6793c3A6F76b448';

// https://snowscan.xyz/address/0x7f7A07FFDe2ab490dad0C0D139d6c730bbe842cC
export const YBTCB__BTC = '0x7f7A07FFDe2ab490dad0C0D139d6c730bbe842cC';

// https://snowscan.xyz/address/0xBb92195Ec95DE626346eeC8282D53e261dF95241
export const BNB__USD = '0xBb92195Ec95DE626346eeC8282D53e261dF95241';

// https://snowscan.xyz/address/0x14488868FC8B1fFB381d6F49907EE75B3f0C2a0F
export const SUSDE__USD = '0x14488868FC8B1fFB381d6F49907EE75B3f0C2a0F';

// https://snowscan.xyz/address/0x2779D32d5166BAaa2B2b658333bA7e6Ec0C65743
export const BTC__USD = '0x2779D32d5166BAaa2B2b658333bA7e6Ec0C65743';

// https://snowscan.xyz/address/0x2854Ca10a54800e15A2a25cFa52567166434Ff0a
export const Calculated_SAVAX__USD = '0x2854Ca10a54800e15A2a25cFa52567166434Ff0a';

// https://snowscan.xyz/address/0x774f067083f23cAB866310489419C884a6Dc00a8
export const MANA__USD = '0x774f067083f23cAB866310489419C884a6Dc00a8';

// https://snowscan.xyz/address/0x3CA13391E9fb38a75330fb28f8cc2eB3D9ceceED
export const AAVE__USD = '0x3CA13391E9fb38a75330fb28f8cc2eB3D9ceceED';

// https://snowscan.xyz/address/0x28043B1Ebd41860B93EC1F1eC19560760B6dB556
export const YFI__USD = '0x28043B1Ebd41860B93EC1F1eC19560760B6dB556';

// https://snowscan.xyz/address/0xAba063634dA21488a0C8A4415cf7651a013B12B5
export const YBTC_BTC_Exchange_Rate = '0xAba063634dA21488a0C8A4415cf7651a013B12B5';

// https://snowscan.xyz/address/0x0A77230d17318075983913bC2145DB16C7366156
export const AVAX__USD = '0x0A77230d17318075983913bC2145DB16C7366156';

// https://snowscan.xyz/address/0x3368310bC4AeE5D96486A73bae8E6b49FcDE62D3
export const EURC__USD = '0x3368310bC4AeE5D96486A73bae8E6b49FcDE62D3';

// https://snowscan.xyz/address/0x94D8c2548018C27F1aa078A23C4158206bE1CC72
export const USDTe_Proof_of_Reserves = '0x94D8c2548018C27F1aa078A23C4158206bE1CC72';

// https://snowscan.xyz/address/0xEBE676ee90Fe1112671f19b6B7459bC678B67e8a
export const USDT__USD = '0xEBE676ee90Fe1112671f19b6B7459bC678B67e8a';

// https://snowscan.xyz/address/0x7CF8A6090A9053B01F3DF4D4e6CfEdd8c90d9027
export const CRV__USD = '0x7CF8A6090A9053B01F3DF4D4e6CfEdd8c90d9027';

// https://snowscan.xyz/address/0x80091AEc326bE58223620D827fd5189FaC8b43C0
export const savBTC_avBTC_Exchange_Rate = '0x80091AEc326bE58223620D827fd5189FaC8b43C0';

// https://snowscan.xyz/address/0x0d2807dc7FA52d3B38be564B64a2b37753C49AdD
export const EmCH_Reserves = '0x0d2807dc7FA52d3B38be564B64a2b37753C49AdD';

// https://snowscan.xyz/address/0x9A9587Da4Fd5DD3C9AD47C12aFeec5073C8cFc2a
export const PCE_Price_Index_Percent_Change_Annual_Rate =
  '0x9A9587Da4Fd5DD3C9AD47C12aFeec5073C8cFc2a';

// https://snowscan.xyz/address/0x63769951E4cfDbDC653dD9BBde63D2Ce0746e5F2
export const USDCe_Proof_of_Reserves = '0x63769951E4cfDbDC653dD9BBde63D2Ce0746e5F2';

// https://snowscan.xyz/address/0xC4D7270aCc921DE5A17452437257f075C1298eB3
export const CHZ__USD = '0xC4D7270aCc921DE5A17452437257f075C1298eB3';

export const CHAIN_ID = 43114;
